import React, {Fragment,Component,useState,useEffect} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import Iframe from "react-iframe"
import { Redirect,Link } from 'react-router-dom';
import { Table,Placeholder } from 'semantic-ui-react';
import {
  Menu,
  Segment,
  Container,
  Divider,
  Message,
  Icon,
  Header,
  Dimmer,
  Responsive,
  Modal,
  Button,
  Image,
  Loader,
  Tab,
  Label
} from 'semantic-ui-react';
import {Base64} from 'js-base64';
import Clipboard from 'react-clipboard.js';

function Guide(props){

  const [synchronized, setSynchronized] = useState(true);
  const [current, setCurrent] = useState(0);

  const {t}       = props;
  const mobile    = /Android|iPhone|iPod/.test(navigator.userAgent);
  const title     = props.data.title;
  const port      = props.data.port;
  const password  = props.data.password;
  const code      = props.data.code;
  const hashed    = props.data.hashed;
  const user_id   = props.data.user_id;
  const user_vip  = props.data.user_vip;

  var subscribe_endpoint = "update.glados-config.com";
  //subscribe_endpoint = "update.glados-config.net";
  //subscribe_endpoint = "update.glados-config.org";

  const suburl           = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`
  const tv_suburl        = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-tv.yaml`
  const singurl          = `https://${subscribe_endpoint}/sft/${user_id}/${hashed}`
  const profile          = `https://${subscribe_endpoint}/surge/${user_id}/${hashed}/glados.network.conf`

  const [clipboard,setClipboard] = useState(false);
  const base = 10;

  return (
  <Fragment>

    <Header as='h2' color="blue">
      {t("settings.tv.title")}
      <Header.Subheader>
      {t("settings.tv.notes")}
      </Header.Subheader>
    </Header>

    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan='3'>
            tvOS 17
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        <Segment>

              <Tab menu={{ color:"blue", secondary: true}} panes={[
                {
                  menuItem:<Menu.Item key='pro33'>Stash For tvOS</Menu.Item>,
                  render: () => {
                    return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
                      <Fragment>
                        <p>1. 在 Apple TV 上登录美区ID </p>
                        <p>2. 升级 Apple TV 到 tvOS 17</p>
                        <p>3. 在 App Store 搜索 Stash 后购买</p>
                        <p>4. 打开 Stash 添加远程配置文件 {tv_suburl}</p>
                        <p>5. 点击启动，并允许配置 VPN </p>
                      </Fragment>
                    </Tab.Pane>)
                  }
                },
                {
                  menuItem:<Menu.Item key='pro33'>Surge For tvOS</Menu.Item>,
                  render: () => {
                    return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
                      <Fragment>
                        <p>1. 在 Apple TV 上登录美区ID </p>
                        <p>2. 升级 Apple TV 到 tvOS 17</p>
                        <p>3. 在 App Store 搜索 Stash 后购买</p>
                        <p>4. 打开 Apple TV 的 Surge</p>
                        <p>5. 在苹果手机上打开 Surge, 点击 More, 点击 Surge tvOS </p>
                        <p>6. 将 Surge iOS 的配置文件({profile})部署到Apple TV</p>
                        <p>7. 在 Apple TV 点击开始</p>
                      </Fragment>
                    </Tab.Pane>)
                  }
                }
              ]} />

        </Segment>
      </Table.Body>
    </Table>

  </Fragment>
  )
}
export {Guide};
